import { defineStore } from 'pinia'
// ai主播列表的store 
export const defaultBackgroundStore = defineStore('backgroundImgStore', {
  state: () => ({
    imgList:[],
    videoList: []
  }),
  getters: {
    getImgList: (state) => {
      return state.imgList
    },
    getVideoList: (state) => {
      return state.videoList
    }
  },
  actions: {
    setImgList(list){
      this.imgList = list;
    },
    setVideoList(list){
      this.videoList = list;
    }
  },
});